import { EntryPermissionCommonAccessRule } from '@/api/types/entry-types';

export enum AccessType {
  registered = 'registered',
  allowCustomList = 'allow-custom-list',
  denyCustomList = 'deny-custom-list',
  private = 'private',
  subscribers = 'subscribers',
  favorites = 'favorites',
  participants = 'participants',
  admins = 'admins'
}

export const accessRuleTypeToAccessTypeMap: Record<
  EntryPermissionCommonAccessRule['type'],
  AccessType | null
> = {
  registered: AccessType.registered,
  private: AccessType.private,
  favorites: AccessType.favorites,
  subscribers: AccessType.subscribers,
  participants: AccessType.participants,
  admins: AccessType.admins
};
